//
// WARNING: this file was auto-generated by @phensley/cldr-compiler. DO NOT EDIT.
//
/* eslint-disable max-len */
export var decimalNumberingDigits = {
    adlm: ["\uD83A\uDD50"],
    ahom: ["\uD805\uDF30"],
    arab: ['٠'],
    arabext: ['۰'],
    bali: ['᭐'],
    beng: ['০'],
    bhks: ["\uD807\uDC50"],
    brah: ["\uD804\uDC66"],
    cakm: ["\uD804\uDD36"],
    cham: ['꩐'],
    deva: ['०'],
    diak: ["\uD806\uDD50"],
    fullwide: ['０'],
    gong: ["\uD807\uDDA0"],
    gonm: ["\uD807\uDD50"],
    gujr: ['૦'],
    guru: ['੦'],
    hanidec: ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九'],
    hmng: ["\uD81A\uDF50"],
    hmnp: ["\uD838\uDD40"],
    java: ['꧐'],
    kali: ['꤀'],
    khmr: ['០'],
    knda: ['೦'],
    lana: ['᪀'],
    lanatham: ['᪐'],
    laoo: ['໐'],
    latn: ['0'],
    lepc: ['᱀'],
    limb: ['᥆'],
    mathbold: ["\uD835\uDFCE"],
    mathdbl: ["\uD835\uDFD8"],
    mathmono: ["\uD835\uDFF6"],
    mathsanb: ["\uD835\uDFEC"],
    mathsans: ["\uD835\uDFE2"],
    mlym: ['൦'],
    modi: ["\uD805\uDE50"],
    mong: ['᠐'],
    mroo: ["\uD81A\uDE60"],
    mtei: ['꯰'],
    mymr: ['၀'],
    mymrshan: ['႐'],
    mymrtlng: ['꧰'],
    newa: ["\uD805\uDC50"],
    nkoo: ['߀'],
    olck: ['᱐'],
    orya: ['୦'],
    osma: ["\uD801\uDCA0"],
    rohg: ["\uD803\uDD30"],
    saur: ['꣐'],
    segment: ["\uD83E\uDFF0"],
    shrd: ["\uD804\uDDD0"],
    sind: ["\uD804\uDEF0"],
    sinh: ['෦'],
    sora: ["\uD804\uDCF0"],
    sund: ['᮰'],
    takr: ["\uD805\uDEC0"],
    talu: ['᧐'],
    tamldec: ['௦'],
    telu: ['౦'],
    thai: ['๐'],
    tibt: ['༠'],
    tirh: ["\uD805\uDCD0"],
    vaii: ['꘠'],
    wara: ["\uD806\uDCE0"],
    wcho: ["\uD838\uDEF0"],
};
//# sourceMappingURL=autogen.names.js.map